import { Component, OnInit } from '@angular/core';
import { InitService } from '../services/init.service';

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.css']
})
export class FileComponent implements OnInit {

  fileDescription = [
    {
      icon: '',
      description: 'nuevos',
      cantidad: 0
    },
    {
      icon: '',
      description: 'pendientes',
      cantidad: 0
    },
    {
      icon: '',
      description: 'cerrados',
      cantidad: 0
    }
  ];


  constructor(private serviceInit: InitService) {
    this.serviceInit.setEstadoLayout(true);
   }

  ngOnInit(): void {
  }

}
